import { getApp } from "firebase/app";
import {
  getStorage,
  listAll,
  ref,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";

export default class FBStorage {
  constructor(app = null) {
    this.app = app || getApp();
    this.storage = getStorage();
  }

  setTenant() {
    this.tenant = localStorage.getItem("ParGolfTenant");
    return this;
  }

  async listAllFiles(path) {
    if (!this.tenant) {
      this.setTenant();
    }

    const formatPath = `${this.tenant}/${path}`;

    const listRef = ref(this.storage, formatPath);
    const allList = await listAll(listRef)
      .then((response) => {
        return response.items;
      })
      .catch((error) => {
        console.error(error);
      });
    return allList;
  }

  async viewDocument(doc) {
    const urlResponse = await getDownloadURL(doc);
    return urlResponse;
  }

  async deleteDocument(doc) {
    if (!this.tenant) {
      this.setTenant();
    }

    const fileRef = ref(this.storage, doc);
    const response = await deleteObject(fileRef);
    return response;
  }
}
